export default __webpack_public_path__ + "static/media/Background_00272.5a3a8e50.png";